define('LNRS/Components/Social/SocialTwitter',["jquery", "eventManager"], function ($, eventManager) {
    function SocialTwitter(scope) {
        eventManager.subscribe("SiteSharingDataLoaded", function (socailSharingData) {
            var fullUrl = '';
            $.each(socailSharingData, function (index, socialNetworkData) {
                if (socialNetworkData.Name.indexOf('Twitter') != -1) {
                    fullUrl = socialNetworkData.FullUrl;
                }
            });
            if (fullUrl.length > 0) {
                $('#social-share-twitter-link').attr('onclick', fullUrl);
            }
        }.bind(this));
    }

    return function init(args) {
        return new SocialTwitter(args.scope);
    };
});
